export const PERMISSIONS = {
  observer: 'They will be able to view everything, but not create or edit',
  creator: 'They will be able to create, edit and collaborate on everything in Great Question, except for billing',
  admin: 'They will be able to create, edit and collaborate on everything in Great Question, including for billing'
};
